// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7642 ? "94a7ad86" : chunkId) + "." + {"7642":"ad0f943f8a0bd8e5","7680":"df654c800aba8bf8"}[chunkId] + ".js";
};